import { CopyExchangeRateToAllBookingItem } from "./CopyExchangeRateToAllBookingItem";

export class CopyGrandTotalExchangeRateToAllBookingItemCommand extends CopyExchangeRateToAllBookingItem {
  CommandName = "CopyGrandTotalExchangeRateToAllBookingItem";

  constructor(
    sessionId: string,
    operationId: string,
    currency: string,
    exchangeDate: string | null,
    exchangeRate: number | null
  ) {
    super(sessionId, operationId, currency, exchangeDate, exchangeRate);
  }
}
